import { render, staticRenderFns } from "./UitklapForm.vue?vue&type=template&id=49bd62a3&scoped=true&"
import script from "./UitklapForm.vue?vue&type=script&lang=js&"
export * from "./UitklapForm.vue?vue&type=script&lang=js&"
import style0 from "./UitklapForm.vue?vue&type=style&index=0&id=49bd62a3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49bd62a3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCheckbox,VFlex,VForm,VIcon,VLayout,VSelect,VTextField})
